import { useEffect, useState } from "react";
import { Box, Container, Tab, Tabs } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ListBoxItem from "@atoms/ListBoxItem";
import { textLimit } from "@helpers/text";
import { TChildProduct, TChildProducts } from "../../../type";

const useStyles = makeStyles(() => ({
  childTab: {
    display: "flex",
    alignItems: "flex-start",
    fontSize: "15px",
    textAlign: "start",
  },
}));

const ChildProducts = (props: { childProduct: TChildProducts; pathParent: string }) => {
  const { childProduct, pathParent } = props;
  const childProductId = `${childProduct[0].id}`;
  const childProducts = childProduct[0].childProduct;
  const classes = useStyles();
  const [selected, setSelected] = useState<string>("");
  const [selectedChildren, setSelectedChildren] = useState<TChildProduct[] | undefined>(
    childProducts,
  );

  useEffect(() => {
    setSelected(childProductId);
    setSelectedChildren(childProducts);
  }, [childProduct]);

  const handleChange = (_event: React.SyntheticEvent, newValue: string) => {
    setSelected(newValue);
    setSelectedChildren(
      childProduct.find((item: { id: string }) => item.id === newValue)?.childProduct,
    );
  };

  return (
    <Box display="flex" flexGrow={1} width="auto">
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={selected}
        scrollButtons={false}
        onChange={handleChange}
        sx={{ borderRight: 1, borderColor: "divider", mr: "44px", minWidth: 268 }}
      >
        {childProduct.map((item: TChildProduct, idx: number) => (
            <Tab
              className={classes.childTab}
              key={idx}
              label={item.productName}
              value={item.id}
            />
          ))}
      </Tabs>
      <Container maxWidth="xl" disableGutters>
        <Box display="flex" gap="24px" flexWrap="wrap">
          {selectedChildren?.map((el: TChildProduct, idx: number) => {
            return (
              <ListBoxItem
                key={idx}
                height={200}
                title={el.productName}
                description={textLimit(el.story, 85)}
                linkTo={`/${pathParent}/${el.productSlug}`}
              />
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};

export default ChildProducts;
